<div class="newField-input-config">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>

      <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <!-- Chữ nền -->
      <h2>{{'chu_nen' | translate}}</h2>
      <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
            [config]="config" [staticdata]="staticdata" [textContentClass]="class['input__input--placeholder']"
            [textWrapperClass]="class['input__input--placeholder']">
          </app-text-format-config>
      <h2>{{'chu_khi_nhap' | translate}}</h2>
        <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
          [config]="config" [staticdata]="staticdata" [textContentClass]="class['input__input']"
          [textWrapperClass]="class['input__input']">
        </app-text-format-config>
    </div>
  </ng-container>

  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- HIỂN THỊ -->
      <li nz-submenu nzTitle="{{'hien_thi'| translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
      </li>
      <!-- CHỌN THÔNG SỐ -->
      <li nz-submenu nzTitle="{{'chon_thong_so' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <mat-form-field *ngIf="staticdata.id_main_sector == 'snimei'" appearance="fill">
            <mat-label>{{'nhom_tra_cuu' | translate}}</mat-label>
            <mat-select [(ngModel)]="staticdata.lookup_group" (ngModelChange)="changeLookupGroup($event)">
              <mat-option *ngFor="let item of lookupGroupArray" [value]="item">
                {{item}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: 100%">
            <mat-label>{{'thong_so_san_pham' | translate}}</mat-label>
            <mat-select [(ngModel)]="staticdata.field_custom" (ngModelChange)="onChangeFieldCustom($event)"
              [disabled]="newFields.length == 0">
              <mat-option *ngFor="let item of newFields" [value]="item.field_custom">{{item?.field_lable ??
                item.field_custom}}</mat-option>
            </mat-select>
          </mat-form-field>
          <p class="line-normal" style="color: rgb(212, 78, 78);">
            {{
              'vui_long_vao_trang_admin_truong_du_lieu_tu_tao_tao_du_lieu_sau_do_quay_lai_day_chon_truong_du_lieu' | translate
            }}
          </p>
      </li>
      <!-- Định dạng chữ gợi ý -->
      <li nz-submenu nzTitle="{{'dinh_dang_chu_goi_y' | translate}}" [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')">
        <div class="container-font">
          <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
            [config]="config" [staticdata]="staticdata" [textContentClass]="class['input__input--placeholder']"
            [textWrapperClass]="class['input__input--placeholder']">
          </app-text-format-config>
        </div>
      </li>
      <!-- Định dạng chữ khi nhập -->
      <li nz-submenu nzTitle="{{'dinh_dang_chu_khi_nhap' | translate}}" [(nzOpen)]="openMap.menu4"
        (nzOpenChange)="openHandler('menu4')">
        <app-text-format-config [device]="device" [objectChoosing]="objectChoosing" [class]="class"
          [config]="config" [staticdata]="staticdata" [textContentClass]="class['input__input']"
          [textWrapperClass]="class['input__input']">
        </app-text-format-config>
      </li>
      <!-- Kiểu viền -->
      <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu5"
        (nzOpenChange)="openHandler('menu5')">
        <div class="main-config">
          <app-borders-config [device]="device" [class]="class" [borderClass]="class['input__boundary']"
            [id_object]="objectChoosing._id" [elementChoosing]="objectChoosing">
          </app-borders-config>
        </div>
      </li>
      <!-- Bo tròn -->
      <li nz-submenu nzTitle="{{'bo_tron' | translate}}" [(nzOpen)]="openMap.menu6"
        (nzOpenChange)="openHandler('menu6')">
        <div class="main-config">
          <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
            [borderRadiusClass]="class['input__boundary']" [id_object]="objectChoosing._id">
          </app-borders-radius-config>
        </div>
      </li>
      <!-- Khoảng đệm -->
      <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu11"
        (nzOpenChange)="openHandler('menu11')">
        <div class="main-config">
          <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
          [classPadding]="class['input__input']" [paddingConfigs]="[
            { type: 'top' },
            { type: 'bottom' },
            { type: 'left' },
            { type: 'right' }
          ]">
          </app-padding-config>
        </div>
      </li>
      <!-- Bật đổ bóng -->
      <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu7"
        (nzOpenChange)="openHandler('menu7')">
        <app-shadow-config [device]="device" [config]="config" [class]="class"
          [shadowClass]="class['input__boundary']" [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>

      </li>
      <!-- Màu nền -->
      <li nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu8"
        (nzOpenChange)="openHandler('menu8')">
        <div class="config-name" style="padding-left: 5px;">
          <p>{{'mau_nen' | translate}}</p>
          <input class="input-color" [style.background]="class['input__input']['background-color']"
            [cpOKButton]="true" [(colorPicker)]="class['input__input']['background-color']"
            (colorPickerClose)="updateClass()" />
        </div>
      </li>

      <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}"  [(nzOpen)]="openMap.menu9"
        (nzOpenChange)="openHandler('menu9')">
        <app-symbol-config 
          [device]="device" 
          [class]="class" 
          [config]="config"
          [symbolClass]="class['input__boundary']" 
          [fontSizeIconClass]="class['input__icon']"
          [symbolConfig]="config['flex-direction']" 
          [objectChoosing]="objectChoosing"
          >
        </app-symbol-config>
      </li>

      <li *ngIf="currentField?.field_input_type == 'input-date'" nz-submenu
        nzTitle="{{'bang_chon_ngay' | translate}}"   [(nzOpen)]="openMap.menu10"
        (nzOpenChange)="openHandler('menu10')" (mouseover)="objectChoosing.isShow = true">
        <ul nz-menu nzMode="inline">
          <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">
            <div class="mb-2 d-flex justify-content-between align-items-center">
              <p class="m-0">{{'ngay_bat_dau'| translate}}</p>
              <nz-select style="width: 100px" [(ngModel)]="staticdata.start_day"
                (ngModelChange)="updateStaticData()">
                <nz-option *ngFor="let item of daysOfWeek" [nzValue]="item.value"
                  nzLabel="{{item.label| translate}}"></nz-option>
              </nz-select>
            </div>
            <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [config]="config" [staticdata]="staticdata" [textContentClass]="class['calendar']"
              [textWrapperClass]="class['calendar']">
            </app-text-format-config>
          </li>

          <li class="pl-2" nz-submenu nzTitle="{{'ngay_hien_tai' | translate}}">
            <ul nz-menu nzMode="inline">

              <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">
                <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [config]="config" [staticdata]="staticdata" [textContentClass]="class['calendar__day--current']"
                  [textWrapperClass]="class['calendar__day--current']">
                </app-text-format-config>
              </li>

              <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="config-name" style="padding-left: 5px;">
                  <p>{{'mau_nen' | translate}}</p>
                  <input class="input-color"
                    [style.background]="class['calendar__day--current']['background-color']" [cpOKButton]="true"
                    [(colorPicker)]="class['calendar__day--current']['background-color']"
                    (colorPickerClose)="updateClass()" />
                </div>
              </li>

              <li class="pl-2" nz-submenu nzTitle="{{'bo_tron' | translate}}">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['calendar__day--current']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>

              <li class="pl-2" nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['calendar__day--current']" [id_object]="objectChoosing._id">
                </app-borders-config>
              </li>
            </ul>
          </li>

          <li class="pl-2" nz-submenu nzTitle="{{'ngay_chon' | translate}}">
            <ul nz-menu nzMode="inline">
              <li class="pl-2" nz-submenu nzTitle="{{'dinh_dang_chu' | translate}}">
                <app-text-format-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [config]="config" [staticdata]="staticdata"
                  [textContentClass]="class['calendar__day--selected']"
                  [textWrapperClass]="class['calendar__day--selected']">
                </app-text-format-config>
              </li>
              <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="config-name" style="padding-left: 5px;">
                  <p>{{'mau_nen' | translate}}</p>
                  <input class="input-color"
                    [style.background]="class['calendar__day--selected']['background-color']" [cpOKButton]="true"
                    [(colorPicker)]="class['calendar__day--selected']['background-color']"
                    (colorPickerClose)="updateClass()" />
                </div>
              </li>

              <li class="pl-2" nz-submenu nzTitle="{{'bo_tron' | translate}}">
                <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderRadiusClass]="class['calendar__day--selected']" [id_object]="objectChoosing._id">
                </app-borders-radius-config>
              </li>

              <li class="pl-2" nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
                  [borderClass]="class['calendar__day--selected']" [id_object]="objectChoosing._id">
                </app-borders-config>
              </li>
            </ul>
          </li>

          <li class="pl-2" nz-submenu nzTitle="{{'mau_nen' | translate}}">
            <div class="config-name" style="padding-left: 5px;">
              <p>{{'mau_nen' | translate}}</p>
              <input class="input-color" [style.background]="class['calendar']['background-color']"
                [cpOKButton]="true" [(colorPicker)]="class['calendar']['background-color']"
                (colorPickerClose)="updateClass()" />
            </div>
          </li>

          <li class="pl-2" nz-submenu nzTitle="{{'bo_tron' | translate}}">
            <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
              [borderRadiusClass]="class['calendar']" [id_object]="objectChoosing._id">
            </app-borders-radius-config>
          </li>
        </ul>
      </li>

    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    
  </div>
</div>